<template>
    <div>
        <div class="crumbs">
            <Breadcrumb v-bind:menuList="menuList"></Breadcrumb>
        </div>
        <div class="container">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane label="充值配置" name="1">
                    <el-form
                        class="form-box"
                        ref="form"
                        v-bind:rules="rules"
                        v-bind:model="form"
                        label-width="120px"
                        label-position="left"
                        label-suffix=":"
                        size="large"
                    >
                        <!-- <el-form-item label="待付款订单取消时间" prop="orderExpireTime">
                    <el-input type="text" auto-complete="off" v-model="form.orderExpireTime" style="width: 100px">
                    </el-input>
                    <span class="desc">分钟内未付款，自动取消订单</span>
                        </el-form-item>-->
                        <!-- <el-form-item label="订单自动确认时间" prop="orderAutoConfirmTime">
                    <el-input type="text" auto-complete="off" v-model="form.orderAutoConfirmTime" style="width: 100px">
                    </el-input>
                    <span class="desc">天，自动确认到货</span>
                        </el-form-item>-->
                        <!-- <el-form> -->
                        <!-- <div> -->
                        <el-form-item prop="close" label="充值配置">
                            <el-switch
                                style="margin-bottom: 10px"
                                v-model="form.close"
                                :active-value="2"
                                :inactive-value="0"
                                @change="changeValue(form)"
                            ></el-switch>
                        </el-form-item>

                        <el-form-item label="最大充值额度" prop="maximum">
                            <el-input v-model.number="form.maximum" placeholder="输入额度"></el-input>
                        </el-form-item>
                        <el-form-item label="最小充值额度" prop="minimum">
                            <el-input v-model.number="form.minimum" placeholder="输入额度"></el-input>
                        </el-form-item>
                        <el-form-item label="微信充值" prop="weixin" class="inline" label-width="90px">
                            <el-switch
                                :active-value="2"
                                :inactive-value="0"
                                v-model="form.weixin"
                                @change="changeFValue(form.weixin, form)"
                            ></el-switch>
                        </el-form-item>
                        <el-form-item label="支付宝充值" prop="zfb" class="inline" label-width="90px">
                            <el-switch
                                :active-value="2"
                                :inactive-value="0"
                                v-model="form.zfb"
                                @change="changeFValue(form.zfb, form)"
                            ></el-switch>
                        </el-form-item>
                        <el-form-item label="余额充值" prop="qianbao" class="inline" label-width="90px">
                            <el-switch
                                :active-value="2"
                                :inactive-value="0"
                                v-model="form.qianbao"
                                @change="changeFValue(form.qianbao, form)"
                            ></el-switch>
                        </el-form-item>
                        <el-form-item :active-value="2" label="银联充值" prop="bank" class="inline" label-width="90px">
                            <el-switch
                                v-model="form.bank"
                                :active-value="2"
                                :inactive-value="0"
                                @change="changeFValue(form.bank, form)"
                            ></el-switch>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm">保 存</el-button>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="提现配置" name="2">
                    <el-form
                        class="form-box"
                        ref="forms"
                        v-bind:rules="rules"
                        v-bind:model="forms"
                        label-position="left"
                        label-width="120px"
                        label-suffix=":"
                        size="large"
                    >
                        <el-form-item prop="close" label="提现配置">
                            <el-switch
                                style="margin-bottom: 10px"
                                v-model="forms.close"
                                :active-value="2"
                                :inactive-value="0"
                                @change="changeValue(forms)"
                            ></el-switch>
                        </el-form-item>
                        <el-form-item label="最大提现额度" prop="maximum">
                            <el-input v-model.number="forms.maximum" placeholder="输入额度"></el-input>
                        </el-form-item>
                        <el-form-item label="最小提现额度" prop="minimum">
                            <el-input v-model.number="forms.minimum" placeholder="输入额度"></el-input>
                        </el-form-item>
                        <el-form-item label="提现到微信" prop="weixin" class="inline" label-width="90px">
                            <el-switch
                                v-model="forms.weixin"
                                :active-value="2"
                                :inactive-value="0"
                                @change="changeFValue(forms.weixin, forms)"
                            ></el-switch>
                        </el-form-item>
                        <el-form-item label="提现到支付宝" prop="zfb" class="inline" label-width="100px">
                            <el-switch
                                v-model="forms.zfb"
                                :active-value="2"
                                :inactive-value="0"
                                @change="changeFValue(forms.zfb, forms)"
                            ></el-switch>
                        </el-form-item>
                        <el-form-item label="提现到余额" prop="qianbao" class="inline" label-width="90px">
                            <el-switch
                                v-model="forms.qianbao"
                                :active-value="2"
                                :inactive-value="0"
                                @change="changeFValue(forms.qianbao, forms)"
                            ></el-switch>
                        </el-form-item>
                        <el-form-item label="提现到银联" prop="bank" class="inline" label-width="90px">
                            <el-switch
                                v-model="forms.bank"
                                :active-value="2"
                                :inactive-value="0"
                                @change="changeFValue(forms.bank, forms)"
                            ></el-switch>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForms">保 存</el-button>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="支付配置" name="3">
                    <el-form
                        class="form-box"
                        ref="formss"
                        v-bind:rules="rules"
                        v-bind:model="formss"
                        label-width="100px"
                        label-position="left"
                        label-suffix=":"
                        size="large"
                    >
                        <el-form-item prop="close" label="支付配置">
                            <el-switch
                                v-model="formss.close"
                                :active-value="2"
                                :inactive-value="0"
                                @change="changeValue(formss.close, formss)"
                            ></el-switch>
                        </el-form-item>
                        <el-form-item label="微信支付" prop="weixin" class="inline">
                            <el-switch
                                v-model="formss.weixin"
                                :active-value="2"
                                :inactive-value="0"
                                @change="changeFValue(formss.weixin, formss)"
                            ></el-switch>
                        </el-form-item>
                        <el-form-item label="微信小程序" prop="weixinmp" class="inline">
                            <el-switch
                                v-model="formss.weixinmp"
                                :active-value="2"
                                :inactive-value="0"
                                @change="changeFValue(formss.weixinmp, formss)"
                            ></el-switch>
                        </el-form-item>

                        <el-form-item label="支付宝支付" prop="zfb" class="inline">
                            <el-switch
                                v-model="formss.zfb"
                                :active-value="2"
                                :inactive-value="0"
                                @change="changeFValue(formss.zfb, formss)"
                            ></el-switch>
                        </el-form-item>
                        <el-form-item label="银联支付" prop="bank" class="inline">
                            <el-switch
                                v-model="formss.bank"
                                :active-value="2"
                                :inactive-value="0"
                                @change="changeFValue(formss.bank, formss)"
                            ></el-switch>
                        </el-form-item>
                        <el-divider>钱包/卡包</el-divider>

                        <el-form-item label="余额支付" prop="qianbao" class="inline">
                            <el-switch
                                v-model="formss.qianbao"
                                :active-value="2"
                                :inactive-value="0"
                                @change="changeFValue(formss.qianbao, formss)"
                            ></el-switch>
                        </el-form-item>
                        <el-form-item label="百联钱包(逸享豆)" prop="okbaifu_pkg" label-width="300px" class="inline">
                            <el-switch
                                v-model="formss.okbaifu_pkg"
                                :active-value="2"
                                :inactive-value="0"
                                @change="changeFValue(formss.okbaifu_pkg, formss)"
                            ></el-switch>
                        </el-form-item>
                        <el-form-item label="皓范智慧食堂" prop="hotfan_new" class="inline">
                            <el-switch
                                v-model="formss.hotfan_new"
                                :active-value="2"
                                :inactive-value="0"
                                @change="changeFValue(formss.hotfan_new, formss)"
                            ></el-switch>
                        </el-form-item>
                        <el-form-item label="皓范国开能源" prop="hotfan_guokai" class="inline">
                            <el-switch
                                v-model="formss.hotfan_guokai"
                                :active-value="2"
                                :inactive-value="0"
                                @change="changeFValue(formss.hotfan_guokai, formss)"
                            ></el-switch>
                        </el-form-item>
                        <el-form-item label="实卡云(科工)" prop="skcxyxf" class="inline">
                            <el-switch
                                v-model="formss.skcxyxf"
                                :active-value="2"
                                :inactive-value="0"
                                @change="changeFValue(formss.skcxyxf, formss)"
                            ></el-switch>
                        </el-form-item>
                        <el-divider>组合支付</el-divider>
                        <!-- 组合支付配置 -->
                        <div class="join-payment-config">
                            <el-form-item prop="close" label="组合支付配置">
                                <el-switch
                                    v-model="formss.join"
                                    :active-value="2"
                                    :inactive-value="0"
                                    @change="changeValue(formss.join, formss)"
                                ></el-switch>
                            </el-form-item>
                            <div v-if="formss.join > 0">
                                <div class="join-payment-item" v-for="(joinItem, index) in joinTypeListTemp" :key="'join-payment-' + index">
                                    <el-form-item :label="'组合支付' + (index + 1)" class="join-payment-form-item">
                                        <el-select
                                            v-model="joinItem[0]"
                                            placeholder="请选择第一种支付方式"
                                            style="width: 200px; margin-right: 10px"
                                        >
                                            <el-option
                                                v-for="item in Object.values(payTypeOptions)"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                            >
                                            </el-option>
                                        </el-select>
                                        <el-select v-model="joinItem[1]" placeholder="请选择第二种支付方式" style="width: 200px">
                                            <el-option
                                                v-for="item in Object.values(payTypeOptions)"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                            >
                                            </el-option>
                                        </el-select>
                                        <el-button
                                            type="danger"
                                            icon="el-icon-delete"
                                            circle
                                            size="mini"
                                            style="margin-left: 10px"
                                            @click="removeJoinPayment(index)"
                                        ></el-button>
                                    </el-form-item>
                                </div>

                                <el-form-item>
                                    <el-button type="primary" icon="el-icon-plus" @click="addJoinPayment"> 添加组合支付 </el-button>
                                </el-form-item>
                            </div>
                        </div>
                        <el-form-item>
                            <el-button type="primary" @click="submitFormss">保 存</el-button>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>

                <el-tab-pane label="交易设置" name="5">
                    <el-form
                        class="form-box trade-form"
                        ref="tradeForm"
                        v-bind:rules="rules"
                        v-bind:model="tradeForm"
                        label-position="left"
                        label-suffix=":"
                        size="large"
                        label-width="180px"
                    >
                        <el-form-item label="售后" prop="aftersales">
                            <el-input v-model.number="tradeForm.aftersales" placeholder="输入售后时间"> </el-input>
                            <span style="margin-left: 10px">天内可维权</span>
                        </el-form-item>
                        <el-form-item label="自动签收" prop="receipt">
                            <el-input v-model.number="tradeForm.receipt" placeholder="输入自动签收时间"></el-input>
                            <span style="margin-left: 10px">天后自动签收</span>
                        </el-form-item>
                        <el-form-item label="佣金配置" prop="commission">
                            <span style="margin-right: 10px">签收后</span>
                            <el-input v-model.number="tradeForm.commission" placeholder="输入佣金配置"></el-input>
                            <span style="margin-left: 10px">天内发放佣金</span>
                        </el-form-item>
                        <el-form-item label="取消订单配置" prop="cancel">
                            <span style="margin-right: 10px">下单后</span>
                            <el-input v-model.number="tradeForm.cancel" placeholder="输入时间"></el-input>
                            <span style="margin-left: 10px">分钟后自动取消订单</span>
                        </el-form-item>
                        <el-form-item label="美团订单溢价比例" prop="cancel">
                            <el-input v-model.number="tradeForm.meituan_premium_rate" placeholder="输入溢价比例">
                                <template slot="append">%</template>
                            </el-input>
                            <div class="desc">
                                计算规则： 当比例为100%，则美团订单金额1元=用户实付金额1元；当比例为200%，=用户实付金额2元
                            </div>
                        </el-form-item>
                        <el-form-item label="仅企业用户可以购买" prop="cancel">
                            <el-switch
                                v-model="tradeForm.enterprise_user_buy_only"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                active-text="仅企业用户"
                                inactive-text="不限制"
                            >
                            </el-switch>
                            <span style="margin-left: 10px">限制后,若用户关联的企业已下线，或超出购买时间，将不能继续购买</span>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitTradeForm">保 存</el-button>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="商城设置" name="6">
                    <el-form
                        class="form-box"
                        ref="storeForm"
                        v-bind:rules="rules"
                        v-bind:model="storeForm"
                        label-position="left"
                        label-suffix=":"
                        size="large"
                        label-width="140px"
                    >
                        <el-form-item label="C端域名" prop="c_domain">
                            <el-input v-model="storeForm.c_domain" placeholder="输入c端域名"></el-input>
                        </el-form-item>
                        <el-form-item label="B端域名" prop="b_domain">
                            <el-input v-model="storeForm.b_domain" placeholder="输入B端域名"></el-input>
                        </el-form-item>
                        <el-form-item label="是否开启私域" prop="private_domain">
                            <el-radio-group v-model="storeForm.private_domain">
                                <el-radio :label="2">是</el-radio>
                                <el-radio :label="1">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="是否开启诸葛埋点" prop="is_zgbury">
                            <el-radio-group v-model="storeForm.is_zgbury">
                                <el-radio :label="2">是</el-radio>
                                <el-radio :label="1">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="是否开启仁联提现" prop="is_renlian">
                            <el-radio-group v-model="storeForm.is_renlian">
                                <el-radio :label="2">是</el-radio>
                                <el-radio :label="1">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitStoreForm">保 存</el-button>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>

                <el-tab-pane label="佣金配置" name="4">
                    <el-form
                        class="form-box"
                        ref="commissionForm"
                        v-bind:rules="rules"
                        v-bind:model="commissionForm"
                        label-position="left"
                        label-suffix=":"
                        size="large"
                    >
                        <el-form-item label="默认佣金比例">
                            <el-input v-model="commissionForm.default_commission" type="number" placeholder="输入比例,1~100%"></el-input>
                        </el-form-item>
                        <el-form-item label="一级佣金比例">
                            <el-input v-model="commissionForm.primary_commission" type="number" placeholder="输入比例,1~100%"></el-input>
                        </el-form-item>
                        <el-form-item label="二级佣金比例">
                            <el-input v-model="commissionForm.secondary_commission" type="number" placeholder="输入比例,1~100%"></el-input>
                        </el-form-item>
                        <el-form-item label="上下级关联绑定时长">
                            <el-input v-model="commissionForm.bind_days" type="number" placeholder="请输入整天数"></el-input> 天
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitCommissionForm">保 存</el-button>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>

                <el-tab-pane label="礼品卡配置" name="7">
                    <div class="disflex">
                        <div class="title">面值配置:</div>
                        <div class="disflex">
                            <el-tag
                                v-for="(tag, index) in denominationList"
                                :key="'denomination-' + index"
                                closable
                                style="margin-right: 10px"
                                @close="removeTag(index)"
                            >
                                {{ tag.num }}
                            </el-tag>

                            <el-button
                                type="primary"
                                v-if="!addDenominationShow"
                                @click="
                                    addDenominationShow = true;
                                    denominationNum = null;
                                "
                                plain
                                size="mini"
                                icon="el-icon-plus"
                                >新增面值</el-button
                            >

                            <template v-if="addDenominationShow">
                                <el-input v-model="denominationNum" type="number" style="margin: 0 20px"></el-input>
                                <el-button type="text" plain size="mini" @click="submitDenomination">确认新增</el-button>
                                <el-button type="text" plain size="mini" @click="addDenominationShow = false">取消</el-button>
                            </template>
                        </div>
                    </div>
                    <div style="margin-top: 60px">
                        <div class="title">打款账户配置:</div>
                        <el-form
                            ref="giftCardFormRef"
                            :rules="rules"
                            :model="giftCardForm"
                            label-position="left"
                            label-suffix=":"
                            size="large"
                            label-width="80px"
                        >
                            <el-form-item label="公司名称">
                                <el-input v-model="giftCardForm.name" placeholder="请输入内容"></el-input>
                            </el-form-item>
                            <el-form-item label="开户行">
                                <el-input v-model="giftCardForm.openingBank" placeholder="请输入内容"></el-input>
                            </el-form-item>
                            <el-form-item label="账户">
                                <el-input v-model="giftCardForm.account" placeholder="请输入内容"></el-input>
                            </el-form-item>
                            <el-form-item label="联行号">
                                <el-input v-model="giftCardForm.interbankNumber" placeholder="请输入内容"></el-input>
                            </el-form-item>
                        </el-form>

                        <el-button type="primary" @click="submitGiftCardForm">保存</el-button>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="积分配置" name="8">
                    <div class="disflex">
                        <div class="disflex">
                            <el-form
                                class="form-box"
                                ref="integralConfForm"
                                :model="integralConfForm"
                                :rules="rules"
                                label-position="left"
                                label-suffix=":"
                                size="large"
                                label-width="140px"
                            >
                                <el-form-item label="积分开关" prop="sync_open">
                                    <el-switch v-model="integralConfForm.open" active-text="开启" inactive-text="关闭"> </el-switch>
                                </el-form-item>

                                <el-form-item label="积分名称" prop="name">
                                    <el-input v-model="integralConfForm.name" placeholder="请输入积分名称" style="width: 300px"></el-input>
                                </el-form-item>

                                <el-form-item label="积分比例" prop="percent">
                                    <el-input
                                        v-model.number="integralConfForm.percent"
                                        type="number"
                                        placeholder="请输入积分比例"
                                        style="width: 300px"
                                    >
                                        <template slot="append">%</template>
                                    </el-input>
                                    <div class="desc">
                                        计算规则： 当比例为100%，则1元=1积分；当比例为500%，则1元=5积分；当比例为1000%，则1元=10积分
                                    </div>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div style="margin-top: 60px">
                        <el-button type="primary" @click="submitIntegralConfForm">保存</el-button>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="239分佣配置" name="9">
                    <div class="disflex">
                        <el-form ref="towThreeNineCommissionForm" :model="towThreeNineCommissionForm">
                            <el-form-item label="直推奖励：">
                                <div class="disflex">
                                    <div class="disflex" style="width: 300px">
                                        <div>第1用户</div>
                                        <el-input
                                            v-model="towThreeNineCommissionForm.direct_reward_commission1"
                                            type="number"
                                            style="margin: 0 5px"
                                            :min="0"
                                        ></el-input>
                                        %
                                    </div>
                                    <div class="disflex" style="margin-left: 20px; width: 300px">
                                        <div>第2用户</div>
                                        <el-input
                                            v-model="towThreeNineCommissionForm.direct_reward_commission2"
                                            type="number"
                                            style="margin: 0 5px"
                                            :min="0"
                                        ></el-input>
                                        %
                                    </div>
                                    <div class="disflex" style="margin-left: 20px; width: 300px">
                                        <div>第3用户</div>
                                        <el-input
                                            v-model="towThreeNineCommissionForm.direct_reward_commission3"
                                            type="number"
                                            style="margin: 0 5px"
                                            :min="0"
                                        ></el-input>
                                        %
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="间推奖励：">
                                <div class="disflex">
                                    <div class="disflex" style="width: 300px">
                                        <el-input
                                            v-model="towThreeNineCommissionForm.second_hand_commission"
                                            type="number"
                                            style="margin: 0 5px"
                                            :min="0"
                                        ></el-input>
                                        %
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="直推津贴：">
                                <div class="disflex">
                                    <div class="disflex" style="width: 300px">
                                        <el-input
                                            v-model="towThreeNineCommissionForm.direct_reward_allowance"
                                            type="number"
                                            style="margin: 0 5px"
                                            :min="0"
                                        ></el-input>
                                        %
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="税收扣点：">
                                <div class="disflex">
                                    <div class="disflex" style="width: 300px">
                                        <el-input
                                            v-model="towThreeNineCommissionForm.tax_deduction"
                                            type="number"
                                            style="margin: 0 5px"
                                            :min="0"
                                        ></el-input>
                                        %
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="确认收货后：">
                                <div class="disflex">
                                    <div class="disflex" style="width: 300px">
                                        <el-input v-model="towThreeNineCommissionForm.name" type="number" style="margin: 0 5px"></el-input>
                                        天分佣
                                    </div>
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div style="margin-top: 60px">
                        <el-button type="primary" @click="commissionSubmit">保存</el-button>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import { request } from '@/common/request';
export default {
    name: 'StoreInfo',
    components: {
        Breadcrumb
    },
    data() {
        return {
            activeName: '1',
            pageInfo: {},
            menuList: ['设置', '交易设置'],
            loading: false,
            value: true,
            rules: {
                maximum: [
                    {
                        required: true,
                        message: '额度不能为空',
                        trigger: 'blur'
                    },
                    {
                        pattern: /^[0-9]*[1-9][0-9]*$/,
                        message: '只能输入整数或小数点后两位数字',
                        type: 'number'
                    }
                ],
                minimum: [
                    {
                        required: true,
                        message: '额度不能为空',
                        trigger: 'blur'
                    },
                    {
                        pattern: /^[1-9]+\d*(\.\d{0,2})?$|^0?\.\d{0,2}$/,
                        message: '只能输入整数或小数点后两位数字',
                        type: 'number'
                    }
                ],
                clerk_commission: [
                    {
                        required: true,
                        message: '店员分佣不能为空',
                        trigger: 'blur'
                    },
                    {
                        message: '请输入数字值',
                        pattern: /^[0-9]*[1-9][0-9]*$/,
                        type: 'number'
                    }
                ],
                shopkeeper_commission: [
                    {
                        required: true,
                        message: '店主佣不能为空',
                        trigger: 'blur'
                    },
                    {
                        message: '请输入数字值',
                        pattern: /^[0-9]*[1-9][0-9]*$/,
                        type: 'number'
                    }
                ],
                aftersales: [
                    {
                        required: true,
                        message: '售后设置不能为空',
                        trigger: 'blur'
                    },
                    {
                        pattern: '^[0-9]*$',
                        message: '请输入数字'
                    }
                ],
                receipt: [
                    {
                        required: true,
                        message: '自动收货不能为空',
                        trigger: 'blur'
                    },
                    {
                        pattern: '^[0-9]*$',
                        message: '请输入数字',
                        type: 'number'
                    }
                ],
                commission: [
                    {
                        required: true,
                        message: '佣金配置不能为空',
                        trigger: 'blur'
                    },
                    {
                        pattern: '^[0-9]*$',
                        message: '请输入数字',
                        type: 'number'
                    }
                ],
                cancel: [
                    {
                        required: true,
                        message: '时间不能为空',
                        trigger: 'blur'
                    },
                    {
                        pattern: '^[0-9]*$',
                        message: '请输入数字',
                        type: 'number'
                    }
                ],
                c_domain: [
                    {
                        required: true,
                        message: 'C端域名不能为空',
                        trigger: 'blur'
                    }
                ],
                b_domain: [
                    {
                        required: true,
                        message: 'B端域名不能为空',
                        trigger: 'blur'
                    }
                ],
                private_domain: [
                    {
                        required: true,
                        message: '是否开启私域不能为空',
                        trigger: 'blur'
                    }
                ],
                is_zgbury: [
                    {
                        required: true,
                        message: '是否开启诸葛埋点不能为空',
                        trigger: 'blur'
                    }
                ],
                is_renlian: [
                    {
                        required: true,
                        message: '是否开启仁联提现不能为空',
                        trigger: 'blur'
                    }
                ],
                'integralConfForm.name': [
                    {
                        required: true,
                        message: '积分名称不能为空',
                        trigger: 'blur'
                    }
                ],
                'integralConfForm.percent': [
                    {
                        required: true,
                        message: '积分比例不能为空',
                        trigger: 'blur'
                    },
                    {
                        type: 'number',
                        message: '请输入有效数字',
                        trigger: 'blur'
                    }
                ]
            },
            form: {
                close: 0,
                weixin: 0,
                zfb: 0,
                qianbao: 0,
                bank: 0,
                maximum: 0,
                minimum: 0
            },
            forms: {
                close: 0,
                weixin: 0,
                zfb: 0,
                qianbao: 0,
                bank: 0,
                maximum: 0,
                minimum: 0
            },
            formss: {
                close: 0,
                weixin: 0,
                weixinmp: 0,
                zfb: 0,
                qianbao: 0,
                okbaifu_pkg: 0,
                hotfan_new: 0,
                hotfan_guokai: 0,
                skcxyxf: 0,
                bank: 0,
                join: 2
            },
            joinTypeListTemp: [['', '']],
            storeForm: {
                // close:2,
                // weixin:0,
                // zfb:0,
                // qianbao:0,
                // bank:0
            },
            tradeForm: {
                b_domain: '',
                c_domain: '',
                is_renlian: 0,
                is_zgbury: 0,
                private_domain: 0,
                enterprise_user_buy_only: false,
                enterprise_user_buy_enable: false
            },
            commissionForm: {
                clerk_commission: 0,
                shopkeeper_commission: 0
            },

            giftCardForm: {
                // 礼品卡
                name: '',
                openingBank: '',
                account: '',
                interbankNumber: ''
            },

            denominationList: [],

            integralConfForm: {
                open: false,
                name: '',
                percent: 0
            },
            payTypeOptions: {
                hotfan_guokai: {
                    label: '皓范国开能源支付',
                    desc: '通过皓范国开能源平台进行支付',
                    value: 'hotfan_guokai',
                    color: '#1aad19'
                }
            },

            denominationNum: null,
            addDenominationShow: false,

            // 239分佣表单
            towThreeNineCommissionForm: {}
        };
    },
    created() {
        this.loadData();
    },
    methods: {
        // tab切换
        handleClick(tab) {
            switch (tab.paneName) {
                case '1':
                    this.loadData();
                    break;
                case '2':
                    this.loadDatas();
                    break;
                case '3':
                    this.loadDatass();
                    break;
                case '4':
                    this.loadCommission();
                    break;
                case '5':
                    this.loadTrade();
                    break;
                case '6':
                    this.loadStoreForm();
                    break;
                case '7':
                    this.loadGiftCard();
                    break;
                case '8':
                    this.loadIntegralConf();
                    break;
                case '9':
                    this.towThreeNineCommission();
                    break;
            }
        },
        // 添加手续费输入框
        addInput() {},
        loadData() {
            this.loading = true;
            request.get('/system/recharge').then((ret) => {
                if (ret.code == 1) {
                    this.loading = false;
                    let aa = ret.data.config;
                    if (Object.keys(ret.data).length > 0) {
                        this.form = ret.data.config;
                    }

                    this.$refs.form.resetFields();
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        loadDatas() {
            this.loading = true;
            request.get('/system/withdrawal').then((ret) => {
                if (ret.code == 1) {
                    this.loading = false;
                    console.log(Object.keys(ret.data).length);
                    if (Object.keys(ret.data).length > 0) {
                        this.forms = ret.data.config;
                    }

                    this.$refs.forms.resetFields();
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        loadDatass() {
            this.loading = true;
            request.get('/system/pay').then((ret) => {
                if (ret.code == 1) {
                    this.loading = false;
                    if (Object.keys(ret.data).length > 0) {
                        this.formss = ret.data.config;
                        this.joinTypeListTemp = this.formss.join_type_list;
                    }
                    this.$refs.formss.resetFields();
                } else {
                    this.$message.error(ret.msg);
                }
            });
            // 获取支付配置
            request.get('/system/transaction/configs').then((ret) => {
                if (ret.code === 1) {
                    this.payTypeOptions = ret.data.payTypeOptions;
                }
            });
        },
        // 获取佣金配置
        towThreeNineCommission() {
            this.loading = true;
            request.get('/system/commission239').then((ret) => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.towThreeNineCommissionForm = ret.data;
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },

        //获取239分佣配置
        loadCommission() {
            this.loading = true;
            request.get('/system/commission').then((ret) => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.commissionForm = ret.data;
                    // this.$refs.commissionForm.resetFields();
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },

        // 获取交易配置
        loadTrade() {
            this.loading = true;
            request.get('/system/transaction/list').then((ret) => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.tradeForm = ret.data;
                    this.$refs.tradeForm.resetFields();
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        // 获取商城配置

        loadStoreForm() {
            this.loading = true;
            request.get('/system/shop/list').then((ret) => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.storeForm = ret.data;
                    this.$refs.storeForm.resetFields();
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        loadGiftCard() {
            this.loading = true;
            request.get('/system/giftCardConfig/get').then((ret) => {
                if (ret.code == 1) {
                    this.loading = false;
                    console.log(ret.data);
                    this.giftCardForm = ret.data.bank;
                    this.denominationList = ret.data.denominationList;
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        // 获取积分配置
        loadIntegralConf() {
            this.loading = true;
            request.get('/system/integral/get').then((ret) => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.integralConfForm = ret.data;
                    if (this.$refs.integralConfForm) {
                        this.$refs.integralConfForm.resetFields();
                    }
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },

        changeValue(aa) {
            console.log(aa);
            if (!aa.close) {
                aa.weixin = 0;
                aa.zfb = 0;
                aa.qianbao = 0;
                aa.bank = 0;
            }
        },
        changeFValue(a, b) {
            if (a) {
                b.close = 2;
            }
            if (!b.weixin && !b.zfb && !b.qianbao && !b.bank) {
                b.close = 0;
            }
        },

        // 保存充值配置
        submitForm() {
            this.loading = true;
            let _this = this;
            request.post('/system/recharge/edit', this.form).then((ret) => {
                if (ret.code == 1) {
                    _this.loadData();
                    this.$refs.form.clearValidate();
                    this.$message.success('充值配置保存成功');
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        // 保存提现配置
        submitForms() {
            let _this = this;
            request.post('/system/withdrawal/edit', this.forms).then((ret) => {
                if (ret.code == 1) {
                    _this.loadDatas();
                    this.$refs.forms.clearValidate();
                    this.$message.success('提现配置保存成功');
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        // 保存支付配置
        submitFormss() {
            // 校验组合支付数据
            if (this.formss.join > 0 && !this.validateJoinPayment()) {
                return; // 校验失败，不继续保存
            }

            let _this = this;
            this.formss.join_type_list = this.joinTypeListTemp;
            request.postJson('/system/pay/edit', this.formss).then((ret) => {
                if (ret.code == 1) {
                    _this.loadDatass();
                    this.$refs.formss.clearValidate();
                    this.$message.success('支付配置保存成功');
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        // 保存交易配置
        submitTradeForm() {
            let _this = this;
            request.post('/system/transaction/edit', this.tradeForm).then((ret) => {
                if (ret.code == 1) {
                    _this.loadTrade();
                    this.$refs.tradeForm.clearValidate();
                    this.$message.success('支付配置保存成功');
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        // 保存商城配置
        submitStoreForm() {
            let _this = this;
            request.post('/system/shop/edit', this.storeForm).then((ret) => {
                if (ret.code == 1) {
                    _this.loadStoreForm();
                    this.$refs.storeForm.clearValidate();
                    this.$message.success('商城配置保存成功');
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },

        submitCommissionForm() {
            let _this = this;
            request.post('/system/commission/edit', this.commissionForm).then((ret) => {
                if (ret.code == 1) {
                    _this.loadCommission();
                    this.$message.success('佣金设置保存成功');
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },

        // 保存礼品卡配置
        submitGiftCardForm() {
            let data = {
                bank: this.giftCardForm,
                denominationList: this.denominationList
            };
            request.postJson('/system/giftCardConfig/edit', data).then((ret) => {
                if (ret.code === 1) {
                    this.loadGiftCard();
                    this.$message.success('礼品卡设置保存成功');
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        // 保存积分配置
        submitIntegralConfForm() {
            let _this = this;
            request.postJson('/system/integral/edit', this.integralConfForm).then((ret) => {
                if (ret.code === 1) {
                    _this.loadIntegralConf();
                    this.$message.success('积分配置保存成功');
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },

        // 保存分佣配置
        commissionSubmit() {
            let _this = this;
            request.post('/system/commission239/edit', this.towThreeNineCommissionForm).then((ret) => {
                if (ret.code === 1) {
                    _this.towThreeNineCommission();
                    this.$message.success('239分佣配置保存成功');
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },

        removeTag(index) {
            this.denominationList.splice(index, 1);
        },
        submitDenomination() {
            // 修复ID重复问题，使用唯一ID
            const newId = Date.now(); // 使用时间戳作为唯一ID
            this.denominationList.push({
                id: newId,
                num: parseInt(this.denominationNum)
            });
            this.addDenominationShow = false;
        },
        // 添加组合支付
        addJoinPayment() {
            console.log('------------addJoinPayment------------');
            // 确保 joinTypeListTemp 存在且为数组
            if (!this.joinTypeListTemp) {
                this.joinTypeListTemp = [];
            }
            this.joinTypeListTemp.push(['', '']);
        },
        // 删除组合支付
        removeJoinPayment(index) {
            console.log('------------removeJoinPayment------------', index);
            // 确保 joinTypeListTemp 存在且为数组
            if (this.joinTypeListTemp) {
                this.joinTypeListTemp.splice(index, 1);
            }
        },
        // 校验组合支付数据
        validateJoinPayment() {
            // 检查 joinTypeListTemp 是否存在
            if (!this.joinTypeListTemp) {
                this.$message.error('组合支付数据未定义');
                return false;
            }
            if (this.joinTypeListTemp.length === 0) {
                this.$message.error('组合支付数据为空');
                return false;
            }

            // 检查是否为数组
            if (!Array.isArray(this.joinTypeListTemp)) {
                this.$message.error('组合支付数据格式错误');
                return false;
            }

            // 检查每个组合支付项
            for (let i = 0; i < this.joinTypeListTemp.length; i++) {
                const joinItem = this.joinTypeListTemp[i];

                // 检查每个组合是否为数组
                if (!Array.isArray(joinItem)) {
                    this.$message.error(`组合支付第${i + 1}项格式错误`);
                    return false;
                }

                // 检查每个组合是否包含恰好两种支付方式
                if (joinItem.length !== 2) {
                    this.$message.error(`组合支付第${i + 1}项必须包含两种支付方式`);
                    return false;
                }

                // 检查每个支付方式是否有效（不为空）
                if (!joinItem[0] || !joinItem[1]) {
                    this.$message.error(`组合支付第${i + 1}项的支付方式不能为空`);
                    return false;
                }

                // 检查两个支付方式是否相同
                if (joinItem[0] === joinItem[1]) {
                    this.$message.error(`组合支付第${i + 1}项的两种支付方式不能相同`);
                    return false;
                }

                // 检查支付方式是否在 payTypeOptions 中存在
                const payTypeValues = Object.values(this.payTypeOptions).map((item) => item.value);
                if (!payTypeValues.includes(joinItem[0])) {
                    this.$message.error(`组合支付第${i + 1}项的第一种支付方式无效`);
                    return false;
                }

                if (!payTypeValues.includes(joinItem[1])) {
                    this.$message.error(`组合支付第${i + 1}项的第二种支付方式无效`);
                    return false;
                }
            }

            return true;
        }
    }
};
</script>

<style scoped>
.desc {
    margin-left: 10px;
    font-size: 14px;
    color: #606266;
}

.inline {
    display: inline-block;
    width: 25%;
}

.money >>> .el-input {
    width: 100px !important;
}
.trade-form {
    width: 1000px;
}

.icon_box {
    width: 30px;
    height: 30px;
    display: inline-block;
    border: 1px solid #dddddd;
    margin-left: 10px;
    text-align: center;
    line-height: 30px;
}

.el-form-item--large.el-form-item {
    margin-top: 30px;
}

.disflex {
    display: flex;
    align-items: center;
}

.title {
    font-size: 16px;
    font-weight: bold;
    margin-right: 20px;
    color: #333;
}

.join-payment-config {
    padding: 20px 0;
}

.join-payment-form-item {
    margin-bottom: 15px;
}
</style>